// src/app/services/encoding.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncodingService {
  
  private encodingMap: { [key: string]: string } = {
    '#': '__HASH__',
    '&': '__AMP__',
    '<': '__LT__',
    '>': '__GT__',
    '"': '__QUOTE__',
    "'": '__APOS__',
    '%': '__PERCENT__',
    '+': '__PLUS__',
    '?': '__QUESTION__',
    '=': '__EQUALS__',
    '/': '__SLASH__',
    '\\': '__BACKSLASH__',
    '`': '__BACKTICK__',
    '$': '__DOLLAR__'
  };

  private decodingMap: { [key: string]: string } = {};

  constructor() {
    // Create reverse mapping for decoding
    Object.keys(this.encodingMap).forEach(key => {
      this.decodingMap[this.encodingMap[key]] = key;
    });
  }

  /**
   * Encode special characters in a string
   */
  encode(value: string): string {
    if (!value || typeof value !== 'string') return value;
    
    let encoded = value;
    Object.keys(this.encodingMap).forEach(char => {
      const regex = new RegExp(this.escapeRegExp(char), 'g');
      encoded = encoded.replace(regex, this.encodingMap[char]);
    });
    
    return encoded;
  }

  /**
   * Decode special characters in a string
   */
  decode(value: string): string {
    if (!value || typeof value !== 'string') return value;
    
    let decoded = value;
    Object.keys(this.decodingMap).forEach(encoded => {
      const regex = new RegExp(this.escapeRegExp(encoded), 'g');
      decoded = decoded.replace(regex, this.decodingMap[encoded]);
    });
    
    return decoded;
  }

  /**
   * Encode all string properties in an object
   */
  encodeObject(obj: any): any {
    if (!obj) return obj;
    
    // Return Date objects unchanged
    if (obj instanceof Date) return obj;
    
    // Handle arrays
    if (Array.isArray(obj)) {
      return obj.map(item => this.encodeObject(item));
    }
    
    const encoded = { ...obj };
    Object.keys(encoded).forEach(key => {
      if (typeof encoded[key] === 'string') {
        encoded[key] = this.encode(encoded[key]);
      } else if (encoded[key] instanceof Date) {
        // Keep Date objects unchanged
        encoded[key] = encoded[key];
      } else if (typeof encoded[key] === 'object' && encoded[key] !== null) {
        encoded[key] = this.encodeObject(encoded[key]);
      }
    });
    
    return encoded;
  }

  /**
   * Decode all string properties in an object
   */
  decodeObject(obj: any): any {
    if (!obj) return obj;
    
    // Return Date objects unchanged
    if (obj instanceof Date) return obj;
    
    // Handle arrays
    if (Array.isArray(obj)) {
      return obj.map(item => this.decodeObject(item));
    }
    
    const decoded = { ...obj };
    Object.keys(decoded).forEach(key => {
      if (typeof decoded[key] === 'string') {
        decoded[key] = this.decode(decoded[key]);
      } else if (decoded[key] instanceof Date) {
        // Keep Date objects unchanged
        decoded[key] = decoded[key];
      } else if (typeof decoded[key] === 'object' && decoded[key] !== null) {
        decoded[key] = this.decodeObject(decoded[key]);
      }
    });
    
    return decoded;
  }

  private escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}